module.exports = "/images/new-form-icon.png?fb5589645659d6ddaf178b4906828ad1";